import { Environment, resolveEnvironment } from './envs-related-data';

/**
 * Constructs the Pype engagement API base URL from the current Pro Studio
 * origin and the channel environment (live/sandbox).
 */
export function buildEngagementApiUrl(
  origin: string,
  channelEnv: 'live' | 'sandbox'
): string {
  const env = resolveEnvironment(origin);
  const sandboxSuffix = channelEnv === 'sandbox' ? '-sandbox' : '';

  switch (env) {
    case Environment.Production:
      return `https://engagement-api${sandboxSuffix}.pypestream.com`;
    case Environment.EU:
      return `https://engagement-api${sandboxSuffix}.pypestream.eu`;
    case Environment.Candidate:
    case Environment.UAT:
    case Environment.Main:
    case Environment.QA1:
    case Environment.QA2:
      return `https://engagement-api${sandboxSuffix}.${env}.pypestream.dev`;
    default:
      // eslint-disable-next-line no-console
      console.warn(
        '[PypeDesigner] Unknown Pro Studio host, falling back to main engagement API'
      );
      return `https://engagement-api${sandboxSuffix}.main.pypestream.dev`;
  }
}
